var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavorite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "favorite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.308 40.768l9.765-5.108a2 2 0 0 1 1.854 0l9.765 5.108c.116.06.221.108.315.144a3.005 3.005 0 0 0-.04-.326l-1.864-10.818a2 2 0 0 1 .578-1.775l7.9-7.661c.086-.084.159-.162.218-.233a3.084 3.084 0 0 0-.323-.063l-10.918-1.579a2 2 0 0 1-1.506-1.09L24.17 7.524a2.97 2.97 0 0 0-.17-.3 2.979 2.979 0 0 0-.17.3l-4.882 9.843a2 2 0 0 1-1.506 1.09L6.525 20.036c-.123.017-.23.039-.324.063.06.071.132.15.218.233l7.9 7.66a2 2 0 0 1 .579 1.776l-1.865 10.818c-.021.122-.034.23-.04.326.094-.036.2-.084.315-.144zM24 39.689l-8.838 4.623c-3.63 1.898-6.766-.374-6.071-4.405l1.685-9.778-7.142-6.926c-2.946-2.857-1.74-6.54 2.318-7.126l9.88-1.428 4.415-8.902c1.818-3.664 5.69-3.66 7.506 0l4.416 8.902 9.879 1.428c4.062.587 5.261 4.272 2.318 7.126l-7.142 6.926 1.685 9.778c.696 4.035-2.445 6.301-6.07 4.405L24 39.69z",
    fillRule: "nonzero",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavorite);
export default __webpack_public_path__ + "static/media/favorite.52ac247730d2a66ae45dda02fea5ebfe.svg";
export { ForwardRef as ReactComponent };